import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import AuthTokenExpired from '@cimpress-technology/react-auth-token-expired-modal';
import { withTranslation } from 'react-i18next';

import { auth } from '../../utils/auth';
import { actions as identityActions, selectors as identitySelectors } from '../../reducers/identities/index';
import { actions as configActions } from '../../reducers/configurations';
import ErrorRobot from '../common/ErrorRobot';
import Loading from '../Loading';

class AuthedRoute extends Component {
  static propTypes = {
    shouldLoadUserIdentities: PropTypes.bool.isRequired,
    userIdentitiesLoaded: PropTypes.bool.isRequired,
    userIdentitiesLoadFailed: PropTypes.bool.isRequired,
    loadUserIdentities: PropTypes.func.isRequired
  };

  componentWillMount() {
    this.ensureLoggedInAndIdentitiesLoaded();
  }

  ensureLoggedInAndIdentitiesLoaded = () => {
    return auth
      .ensureAuthentication({ nextUri: window.location.pathname + window.location.search })
      .then(isAuthenticated => {
        if (isAuthenticated && this.props.shouldLoadUserIdentities) {
          this.props.loadUserIdentities();
          this.props.fetchUserConfig();
        }
      });
  };

  authedRender = componentProps => {
    if (auth.isLoggedIn()) {
      if (this.props.userIdentitiesLoaded) {
        if (!this.props.hasFulfillerIds && !this.props.hasMerchantIds) {
          return <ErrorRobot msg={this.props.t('errors:error_forbidden')} />;
        }
        return React.createElement(this.props.component, componentProps);
      }
    }
    if (this.props.userIdentitiesLoadFailed) {
      return <ErrorRobot msg={this.props.t('errors:error_unknown')} />;
    }

    return <Loading />;
  };

  render() {
    const { component, ...routerProps } = this.props;
    return (
      <>
        <AuthTokenExpired authWrapper={auth} onLogin={this.ensureLoggedInAndIdentitiesLoaded} />
        <Route {...routerProps} render={props => this.authedRender(props)} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  shouldLoadUserIdentities: identitySelectors.shouldLoadUserIdentities(state),
  userIdentitiesLoaded: identitySelectors.getUserIdentitiesLoaded(state),
  userIdentitiesLoadFailed: identitySelectors.getUserIdentitiesLoadFailed(state),
  hasFulfillerIds: identitySelectors.getHasFulfillerIdentities(state),
  hasMerchantIds: identitySelectors.getHasMerchantIdentities(state)
});

const mapDispatchToProps = {
  loadUserIdentities: identityActions.loadUserIdentities,
  fetchUserConfig: configActions.fetchUserConfig
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(AuthedRoute));
